import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import MenuRightDrawerRight from './MenuRightDrawerRight.style';

export default withRouter(withTranslation()(MenuRightDrawerRight));
